import { calculateAvailableBorrowsMarketReferenceCurrency, calculateHealthFactorFromBalances, } from '../../pool-math';
import { normalizedToUsd } from '../usd/normalized-to-usd';
import { calculateUserReserveTotals } from './calculate-user-reserve-totals';
export function generateRawUserSummary({ userReserves, userERC1155Reserves, marketReferencePriceInUsd, marketReferenceCurrencyDecimals, }) {
    const { totalLiquidityMarketReferenceCurrency, totalBorrowsMarketReferenceCurrency, totalCollateralMarketReferenceCurrency, currentLtv, currentLiquidationThreshold, } = calculateUserReserveTotals({ userReserves, userERC1155Reserves });
    const availableBorrowsMarketReferenceCurrency = calculateAvailableBorrowsMarketReferenceCurrency({
        collateralBalanceMarketReferenceCurrency: totalCollateralMarketReferenceCurrency,
        borrowBalanceMarketReferenceCurrency: totalBorrowsMarketReferenceCurrency,
        currentLtv,
    });
    return {
        totalLiquidityUSD: normalizedToUsd(totalLiquidityMarketReferenceCurrency, marketReferencePriceInUsd, marketReferenceCurrencyDecimals),
        totalCollateralUSD: normalizedToUsd(totalCollateralMarketReferenceCurrency, marketReferencePriceInUsd, marketReferenceCurrencyDecimals),
        totalBorrowsUSD: normalizedToUsd(totalBorrowsMarketReferenceCurrency, marketReferencePriceInUsd, marketReferenceCurrencyDecimals),
        totalLiquidityMarketReferenceCurrency,
        totalCollateralMarketReferenceCurrency,
        totalBorrowsMarketReferenceCurrency,
        availableBorrowsMarketReferenceCurrency,
        availableBorrowsUSD: normalizedToUsd(availableBorrowsMarketReferenceCurrency, marketReferencePriceInUsd, marketReferenceCurrencyDecimals),
        currentLoanToValue: currentLtv,
        currentLiquidationThreshold,
        healthFactor: calculateHealthFactorFromBalances({
            collateralBalanceMarketReferenceCurrency: totalCollateralMarketReferenceCurrency,
            borrowBalanceMarketReferenceCurrency: totalBorrowsMarketReferenceCurrency,
            currentLiquidationThreshold,
        }),
    };
}
//# sourceMappingURL=generate-raw-user-summary.js.map